import { useEffect, useState } from "react";
import { CommunityFormEnum } from "./enums/CommunityFormEnum";
import { toAbsoluteUrl } from "../../../_metronic/helpers";
import { useHistory, useLocation } from "react-router-dom";

export const CommunityFinishFormPage = () => {
    const { search } = useLocation();
    const history = useHistory();
    const [ type, setType ] = useState<CommunityFormEnum>(CommunityFormEnum.OPEN_DISCUSSION);

    useEffect(() => {
        document.body.classList.add('community-wrapper', 'community-success-wrapper')
        return () => document.body.classList.remove('community-wrapper', 'community-success-wrapper')
    }, []);

    useEffect(() => {
        const params = new URLSearchParams(search); 
        const _defaulType = params.get("type");
        if(_defaulType === '1')
            setType(CommunityFormEnum.OPEN_DISCUSSION)
        else if(_defaulType === '2') // *** Falta validación
            setType(CommunityFormEnum.MASTERMIND_CIRCLE)
    }, [search]);

    return (
        <div className="community-success">
            <div className="community-success__info">
                <h2>
                    { type === CommunityFormEnum.MASTERMIND_CIRCLE ? (
                        'Mastermind Circle '
                    ): (
                        'Open Discussion '
                    )}
                    is created.
                </h2>

                <span>
                    It will be reviewed and you’ll be notified once published.
                </span>

                  <div className='nbx-lines' aria-hidden='true'>
                    <span className='nbx-lines__line' />
                    <span>
                        <img src='/media/svg/nobilis/mark.svg' alt='divider' className='payment-card__icon' />
                    </span>
                    <span className='nbx-lines__line' />
                </div>


                <button onClick={() => history.replace(`/community`)}>
                    explore community
                    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="4" viewBox="0 0 14 4" fill="none">
                        <path d="M8.5 0.378906L12 3.38306H0" stroke="#151515"/>
                    </svg>
                </button>


            </div>

            <div className="community-success__background">
                <img src={toAbsoluteUrl('/media/c_footer.png')} />
            </div>
        </div>
    )
}   